import React, { useState } from 'react';

function Workflows({ showToast }) {
  const [activeTab, setActiveTab] = useState('flow1-1');
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);

  const activeWorkflows = [
    { id: 'ALT-001', customer: 'Công ty TNHH ABC', step: 'Điều tra và phân tích', assignee: 'Lê Văn C', deadline: '26/05/2026', progress: 60 },
    { id: 'ALT-006', customer: 'Nguyễn Thị D', step: 'Chờ phê duyệt', assignee: 'Trần Thị B', deadline: '26/05/2026', progress: 85 },
    { id: 'ALT-012', customer: 'Công ty CP XYZ', step: 'Phân công xử lý', assignee: 'Phạm Thị D', deadline: '27/05/2026', progress: 30 }
  ];

  const simulateNotification = () => {
    showToast('📧 Email đã gửi đến: risk-manager@bank.com', 'success');
    setTimeout(() => showToast('📱 SMS đã gửi đến: Trưởng phòng tín dụng', 'success'), 500);
    setTimeout(() => showToast('🔔 Thông báo popup trên Dashboard', 'info'), 1000);
    setTimeout(() => showToast('✅ Task ưu tiên cao đã được tạo', 'warning'), 1500);
  };

  const handleAssignment = (e) => {
    e.preventDefault();
    showToast('✅ Đã phân công cho chuyên viên thành công', 'success');
    setShowAssignModal(false);
  };

  const handleApproval = (e) => {
    e.preventDefault();
    showToast('✅ Đã phê duyệt giải pháp xử lý thành công', 'success');
    setShowApprovalModal(false);
    setTimeout(() => showToast('📝 Đã chuyển sang bước triển khai', 'info'), 1000);
  };

  return (
    <div className="container-fluid p-4">
      <div className="page-header-sticky">
        <div>
          <h2 className="mb-1">
            <i className="bi bi-arrow-repeat me-2"></i>
            Quy trình Workflow
          </h2>
          <p className="text-muted mb-0">Theo dõi và quản lý các quy trình xử lý cảnh báo</p>
        </div>
      </div>

      {/* Active Workflows */}
      <div className="card mb-4">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">
            <i className="bi bi-clock-history me-2"></i>
            Workflow đang xử lý
          </h5>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Mã cảnh báo</th>
                  <th>Khách hàng</th>
                  <th>Bước hiện tại</th>
                  <th>Người xử lý</th>
                  <th>Deadline</th>
                  <th>Tiến độ</th>
                </tr>
              </thead>
              <tbody>
                {activeWorkflows.map((wf, index) => (
                  <tr key={index}>
                    <td><strong>{wf.id}</strong></td>
                    <td>{wf.customer}</td>
                    <td><span className="badge bg-warning">{wf.step}</span></td>
                    <td>{wf.assignee}</td>
                    <td><small className="text-muted">{wf.deadline}</small></td>
                    <td>
                      <div className="progress" style={{width: '120px', height: '20px'}}>
                        <div 
                          className="progress-bar bg-success" 
                          style={{width: `${wf.progress}%`}}
                        >
                          {wf.progress}%
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Workflow Tabs */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button 
            className={`nav-link ${activeTab === 'flow1-1' ? 'active' : ''}`}
            onClick={() => setActiveTab('flow1-1')}
          >
            🔴 Luồng 1.1: Rủi ro CAO
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link ${activeTab === 'flow1-2' ? 'active' : ''}`}
            onClick={() => setActiveTab('flow1-2')}
          >
            🟡 Luồng 1.2: Rủi ro THƯỜNG
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link ${activeTab === 'flow2-1' ? 'active' : ''}`}
            onClick={() => setActiveTab('flow2-1')}
          >
            ⚙️ Luồng 2.1: Cấu hình mô hình
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link ${activeTab === 'flow2-2' ? 'active' : ''}`}
            onClick={() => setActiveTab('flow2-2')}
          >
            📊 Luồng 2.2: Giám sát & Đánh giá
          </button>
        </li>
      </ul>

      {/* Workflow Content */}
      <div className="card">
        <div className="card-body">
          {activeTab === 'flow1-1' && (
            <div>
              <h4 className="text-danger mb-4">
                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                Luồng 1.1: Xử lý cảnh báo RỦI RO CAO (≥80 điểm)
              </h4>
              
              <div className="workflow-steps">
                <div className="workflow-step">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h5>Phát hiện cảnh báo</h5>
                    <p>⚙️ Hệ thống tự động phát hiện khi điểm cảnh báo ≥ 80</p>
                    <p>🤖 Tự động tạo cảnh báo trong hệ thống</p>
                  </div>
                </div>

                <div className="workflow-step">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h5>Thông báo khẩn cấp</h5>
                    <p>📧 Email đến Quản lý rủi ro</p>
                    <p>📱 SMS đến Trưởng phòng tín dụng</p>
                    <p>🔔 Popup trên Dashboard</p>
                    <p>📝 Tạo task ưu tiên cao</p>
                    <button 
                      className="btn btn-sm btn-primary mt-2"
                      onClick={simulateNotification}
                    >
                      <i className="bi bi-bell"></i> Gửi thông báo
                    </button>
                  </div>
                </div>

                <div className="workflow-step">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h5>Phân công xử lý</h5>
                    <p>👤 Quản lý chọn chuyên viên xử lý</p>
                    <p>⏰ Đặt thời hạn xử lý (tối đa 24h)</p>
                    <p>📋 Ghi chú yêu cầu cụ thể</p>
                    <button 
                      className="btn btn-sm btn-success mt-2"
                      onClick={() => setShowAssignModal(true)}
                    >
                      <i className="bi bi-person-plus"></i> Phân công
                    </button>
                  </div>
                </div>

                <div className="workflow-step">
                  <div className="step-number">4</div>
                  <div className="step-content">
                    <h5>Điều tra và phân tích</h5>
                    <p>📞 Liên hệ khách hàng xác minh thông tin</p>
                    <p>📄 Thu thập tài liệu bổ sung</p>
                    <p>🔍 Phân tích nguyên nhân gốc rễ</p>
                    <p>💰 Đánh giá khả năng thanh toán</p>
                  </div>
                </div>

                <div className="workflow-step">
                  <div className="step-number">5</div>
                  <div className="step-content">
                    <h5>Đề xuất giải pháp</h5>
                    <p><strong>Phương án A:</strong> Cơ cấu lại nợ</p>
                    <p><strong>Phương án B:</strong> Yêu cầu tài sản bảo đảm bổ sung</p>
                    <p><strong>Phương án C:</strong> Thu hồi nợ</p>
                    <p><strong>Phương án D:</strong> Xử lý nợ xấu</p>
                  </div>
                </div>

                <div className="workflow-step">
                  <div className="step-number">6</div>
                  <div className="step-content">
                    <h5>Phê duyệt giải pháp</h5>
                    <p>👔 Trưởng phòng xem xét đề xuất</p>
                    <p>✅ Phê duyệt / ❌ Từ chối / ✏️ Yêu cầu bổ sung</p>
                    <p>📝 Ghi chú ý kiến phê duyệt</p>
                    <button 
                      className="btn btn-sm btn-warning mt-2"
                      onClick={() => setShowApprovalModal(true)}
                    >
                      <i className="bi bi-check-circle"></i> Phê duyệt
                    </button>
                  </div>
                </div>

                <div className="workflow-step">
                  <div className="step-number">7</div>
                  <div className="step-content">
                    <h5>Thực hiện và theo dõi</h5>
                    <p>🎯 Triển khai giải pháp đã được phê duyệt</p>
                    <p>📈 Giám sát tiến độ thực hiện</p>
                    <p>📊 Báo cáo định kỳ về tình hình</p>
                    <p>✅ Đóng cảnh báo khi hoàn thành</p>
                  </div>
                </div>
              </div>

              <div className="alert alert-info mt-4">
                <i className="bi bi-clock"></i> <strong>Thời gian xử lý:</strong> 2-7 ngày làm việc
              </div>
            </div>
          )}

          {activeTab === 'flow1-2' && (
            <div>
              <h4 className="text-warning mb-4">
                <i className="bi bi-exclamation-circle-fill me-2"></i>
                Luồng 1.2: Xử lý cảnh báo RỦI RO THƯỜNG
              </h4>
              
              <div className="row">
                <div className="col-md-6">
                  <div className="card border-warning">
                    <div className="card-header bg-warning">
                      <h5 className="mb-0">Rủi ro Trung bình (50-79 điểm)</h5>
                    </div>
                    <div className="card-body">
                      <ol>
                        <li>Ghi nhận cảnh báo tự động</li>
                        <li>Gửi email tổng hợp hằng ngày</li>
                        <li>Xem xét và phân loại trong 3-5 ngày</li>
                        <li>Liên hệ khách hàng nhắc nhở</li>
                        <li>Theo dõi định kỳ hằng tuần</li>
                      </ol>
                      <div className="alert alert-warning mt-3">
                        <small>⚠️ Tự động chuyển sang Luồng 1.1 nếu điểm ≥ 80</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="card border-info">
                    <div className="card-header bg-info text-white">
                      <h5 className="mb-0">Rủi ro Thấp (&lt;50 điểm)</h5>
                    </div>
                    <div className="card-body">
                      <ol>
                        <li>Ghi nhận vào báo cáo tuần</li>
                        <li>Giám sát xu hướng biến động</li>
                        <li>Không cần hành động ngay</li>
                        <li>Cảnh báo nếu điểm tăng đột biến</li>
                        <li>Xem xét lại trong báo cáo tháng</li>
                      </ol>
                      <div className="alert alert-info mt-3">
                        <small>📊 Phân tích xu hướng để phát hiện sớm</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'flow2-1' && (
            <div>
              <h4 className="text-primary mb-4">
                <i className="bi bi-gear-fill me-2"></i>
                Luồng 2.1: Cấu hình & Triển khai Mô hình EWS
              </h4>
              
              <div className="workflow-steps">
                <div className="workflow-step">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h5>Thu thập yêu cầu</h5>
                    <p>👥 Họp các bộ phận liên quan</p>
                    <p>🎯 Xác định mục tiêu mô hình</p>
                    <p>📋 Liệt kê các chỉ tiêu cần thiết</p>
                  </div>
                </div>

                <div className="workflow-step">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h5>Thiết kế mô hình</h5>
                    <p>🔧 Chọn loại mô hình phù hợp</p>
                    <p>⚖️ Xác định chỉ tiêu và trọng số</p>
                    <p>📊 Thiết lập ngưỡng cảnh báo</p>
                  </div>
                </div>

                <div className="workflow-step">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h5>Cấu hình chi tiết</h5>
                    <p>💾 Tạo các chỉ tiêu trong hệ thống</p>
                    <p>🔌 Cấu hình nguồn dữ liệu</p>
                    <p>📐 Thiết lập công thức tính toán</p>
                  </div>
                </div>

                <div className="workflow-step">
                  <div className="step-number">4</div>
                  <div className="step-content">
                    <h5>Thử nghiệm</h5>
                    <p>🧪 Chạy với dữ liệu lịch sử</p>
                    <p>📈 So sánh kết quả với thực tế</p>
                    <p>🔧 Điều chỉnh trọng số nếu cần</p>
                  </div>
                </div>

                <div className="workflow-step">
                  <div className="step-number">5</div>
                  <div className="step-content">
                    <h5>Triển khai</h5>
                    <p>📝 Trình phê duyệt ban quản lý</p>
                    <p>👨‍🏫 Đào tạo người dùng</p>
                    <p>🚀 Kích hoạt mô hình</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'flow2-2' && (
            <div>
              <h4 className="text-success mb-4">
                <i className="bi bi-graph-up me-2"></i>
                Luồng 2.2: Giám sát & Đánh giá Hiệu quả
              </h4>
              
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header bg-success text-white">
                      <h5 className="mb-0">Giám sát hằng ngày</h5>
                    </div>
                    <div className="card-body">
                      <ul>
                        <li>📊 Kiểm tra số lượng cảnh báo mới</li>
                        <li>✅ Theo dõi trạng thái xử lý</li>
                        <li>📈 Xem Dashboard tổng quan</li>
                        <li>🚨 Phát hiện bất thường</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header bg-primary text-white">
                      <h5 className="mb-0">Báo cáo định kỳ</h5>
                    </div>
                    <div className="card-body">
                      <ul>
                        <li>📅 <strong>Tuần:</strong> Tổng hợp cảnh báo</li>
                        <li>📆 <strong>Tháng:</strong> Phân tích xu hướng</li>
                        <li>📊 <strong>Quý:</strong> Đánh giá hiệu suất</li>
                        <li>📈 <strong>Năm:</strong> Tổng kết & cải tiến</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="card">
                    <div className="card-header bg-warning">
                      <h5 className="mb-0">Đánh giá hiệu quả mô hình - KPI</h5>
                    </div>
                    <div className="card-body">
                      <div className="row text-center">
                        <div className="col-md-3">
                          <h3 className="text-success">92%</h3>
                          <p>Accuracy<br/><small className="text-muted">Độ chính xác</small></p>
                        </div>
                        <div className="col-md-3">
                          <h3 className="text-success">88%</h3>
                          <p>Precision<br/><small className="text-muted">Độ chính xác dương</small></p>
                        </div>
                        <div className="col-md-3">
                          <h3 className="text-success">85%</h3>
                          <p>Recall<br/><small className="text-muted">Độ nhạy</small></p>
                        </div>
                        <div className="col-md-3">
                          <h3 className="text-success">86.5%</h3>
                          <p>F1-Score<br/><small className="text-muted">Điểm tổng hợp</small></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="card">
                    <div className="card-header bg-info text-white">
                      <h5 className="mb-0">Tối ưu hóa & Cải tiến</h5>
                    </div>
                    <div className="card-body">
                      <ul>
                        <li>🔧 Điều chỉnh trọng số các chỉ tiêu</li>
                        <li>📊 Cập nhật ngưỡng cảnh báo</li>
                        <li>➕ Thêm chỉ tiêu mới</li>
                        <li>➖ Loại bỏ chỉ tiêu không hiệu quả</li>
                        <li>🔄 Cải thiện quy trình xử lý</li>
                        <li>👨‍🏫 Đào tạo và cập nhật kiến thức</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Assign Modal */}
      {showAssignModal && (
        <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">Phân công xử lý cảnh báo</h5>
                <button 
                  type="button" 
                  className="btn-close btn-close-white" 
                  onClick={() => setShowAssignModal(false)}
                ></button>
              </div>
              <form onSubmit={handleAssignment}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Mã cảnh báo</label>
                    <input type="text" className="form-control" value="ALT-001" readOnly />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Khách hàng</label>
                    <input type="text" className="form-control" value="Công ty TNHH ABC" readOnly />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Phân công cho <span className="text-danger">*</span></label>
                    <select className="form-select" required>
                      <option value="">Chọn chuyên viên</option>
                      <option>Lê Văn C - Chuyên viên cao cấp</option>
                      <option>Phạm Thị D - Chuyên viên</option>
                      <option>Hoàng Văn E - Chuyên viên</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Thời hạn xử lý <span className="text-danger">*</span></label>
                    <input type="datetime-local" className="form-control" required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Ghi chú</label>
                    <textarea className="form-control" rows="3" placeholder="Yêu cầu xử lý khẩn cấp..."></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  <button 
                    type="button" 
                    className="btn btn-secondary" 
                    onClick={() => setShowAssignModal(false)}
                  >
                    Hủy
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Phân công
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Approval Modal */}
      {showApprovalModal && (
        <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-success text-white">
                <h5 className="modal-title">Phê duyệt giải pháp xử lý</h5>
                <button 
                  type="button" 
                  className="btn-close btn-close-white" 
                  onClick={() => setShowApprovalModal(false)}
                ></button>
              </div>
              <form onSubmit={handleApproval}>
                <div className="modal-body">
                  <div className="alert alert-info">
                    <strong>Cảnh báo:</strong> ALT-001 - Công ty TNHH ABC
                  </div>
                  
                  <h6 className="text-primary">Đề xuất từ chuyên viên: Lê Văn C</h6>
                  <div className="card mb-3">
                    <div className="card-body">
                      <h6>Phương án A: Cơ cấu lại nợ</h6>
                      <ul>
                        <li>Gia hạn nợ thêm 12 tháng</li>
                        <li>Điều chỉnh lãi suất xuống 8%/năm</li>
                        <li>Yêu cầu bổ sung tài sản bảo đảm</li>
                      </ul>
                      <p><strong>Ưu điểm:</strong> Giúp KH có thời gian khắc phục, giảm rủi ro nợ xấu</p>
                      <p><strong>Nhược điểm:</strong> Kéo dài thời gian thu hồi, tăng rủi ro</p>
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Quyết định <span className="text-danger">*</span></label>
                    <select className="form-select" required>
                      <option value="">Chọn quyết định</option>
                      <option>✅ Phê duyệt</option>
                      <option>❌ Từ chối</option>
                      <option>✏️ Yêu cầu bổ sung</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Ý kiến phê duyệt <span className="text-danger">*</span></label>
                    <textarea className="form-control" rows="4" required placeholder="Nhập ý kiến của bạn..."></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  <button 
                    type="button" 
                    className="btn btn-secondary" 
                    onClick={() => setShowApprovalModal(false)}
                  >
                    Đóng
                  </button>
                  <button type="submit" className="btn btn-success">
                    <i className="bi bi-check-circle"></i> Xác nhận phê duyệt
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Workflows;
